<template>
  <v-container fluid class="development-page">
    <v-row align="center" justify="center" class="full-height">
      <v-col cols="12" md="8" class="text-center">
        <v-icon large color="primary">mdi-tools</v-icon>
        <h1 class="display-2 font-weight-bold">Em Desenvolvimento</h1>
        <p class="subheading">Nosso blog está quase pronto! Em breve você poderá conferir novidades e artigos.</p>
        <v-btn color="primary" href="/" class="mt-4">Voltar para a Home</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'BlogPage',
}
</script>

<style scoped>
.development-page {
  min-height: 100vh;
  background-color: #fafafa;
}

.development-page .v-btn {
  border-radius: 25px;
}
</style>
